import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

interface Section {
  id: string;
  title: string;
  content: string[];
}

const sections: Section[] = [
  {
    id: "1",
    title: "第1条（目的・適用範囲）",
    content: [
      "本利用規約（以下「本規約」）は、TSUGITE（ツギテ）の運営者（以下「運営者」）が提供する教育ECプラットフォーム「TSUGITE」（以下「本サービス」）の利用に関し、運営者と利用者との間の権利義務関係を定めるものです。",
      "本サービスを利用する場合、利用者は本規約のすべての内容に同意したものとみなします。本規約に同意されない場合は、本サービスをご利用いただけません。",
      "運営者は、本規約を随時変更することがあります。変更後の規約は、本サービス上に掲示された時点で効力を生じます。変更後も継続してご利用いただいた場合は、変更後の規約に同意したものとみなします。",
    ],
  },
  {
    id: "2",
    title: "第2条（定義）",
    content: [
      "「利用者」とは、本サービスに会員登録した方（消費者・事業者のいずれも含む）をいいます。",
      "「消費者」とは、本サービスにおいて動画講座・教材キットを購入・閲覧する目的で登録した利用者をいいます。",
      "「事業者」とは、本サービスにおいて動画講座・教材キットを出品・販売する目的で登録した利用者をいいます。",
      "「コンテンツ」とは、動画講座・教材キットおよびこれらに付随する説明文・画像・音声等のデジタルコンテンツをいいます。",
      "「メッセージ機能」とは、購入済みのコンテンツがある事業者と消費者が個別にテキストメッセージを送受信できる機能をいいます。",
    ],
  },
  {
    id: "3",
    title: "第3条（会員登録・アカウント管理）",
    content: [
      "本サービスの会員登録は、登録申請者が本規約に同意のうえ、所定の手続きに従って行うものとします。",
      "未成年者が会員登録を行う場合は、法定代理人の同意が必要です。",
      "利用者は、登録情報を正確かつ最新の状態に保つ義務を負います。虚偽の情報による登録は禁止されています。",
      "アカウントのIDおよびパスワードは利用者自身が責任をもって管理してください。第三者への貸与・譲渡・売買は禁止されています。",
      "アカウントを通じて行われた一切の行為は、当該アカウントの利用者による行為とみなします。",
      "利用者は、アカウントの不正利用を発見した場合、直ちに運営者に通知するものとします。",
    ],
  },
  {
    id: "4",
    title: "第4条（出品・販売に関するルール）",
    content: [
      "事業者は、本サービスで出品できるコンテンツを、合法かつ技術的・教育的価値のある動画講座および教材キットに限定します。",
      "事業者は、自己が権利を有するコンテンツ、または正当な権利を取得したコンテンツのみを出品するものとします。第三者の知的財産権・著作権を侵害するコンテンツの出品は禁止されています。",
      "誇大・虚偽の表現、詐欺的な販売行為は固く禁じます。商品説明は正確かつ誠実なものとしてください。",
      "教材キットについては、関係する法令（化粧品・医薬品・食品衛生法等）を遵守したうえで出品・販売してください。",
      "運営者は、出品コンテンツが本規約または法令に違反すると判断した場合、事前通知なく非公開・削除することができます。",
      "販売手数料は、フリープランが販売価格の20%、ライトプランが10%です。手数料は売上から差し引いて精算されます。",
    ],
  },
  {
    id: "5",
    title: "第5条（購入・返金・キャンセル）",
    content: [
      "消費者が動画講座を購入した場合、決済完了後に視聴権が付与されます。デジタルコンテンツの性質上、購入後の返品・返金は原則としてお受けしていません。",
      "ただし、運営者または事業者の重大な過失により購入コンテンツが利用不能な場合は、運営者の判断により返金対応を行うことがあります。",
      "教材キットの返品・交換は、法令上認められる場合（消費者契約法等）を除き、各事業者の定める条件に従います。",
      "決済完了前のキャンセルは購入手続き画面から可能ですが、決済完了後のキャンセルは上記返金ポリシーが適用されます。",
    ],
  },
  {
    id: "6",
    title: "第6条（メッセージ機能の利用規則）",
    content: [
      "メッセージ機能は、購入済みのコンテンツがある事業者との間でのみ利用可能です。学習・技術に関する質問・相談を目的として設計されています。",
      "メッセージ機能を通じた以下の行為を禁止します：サービス外での取引勧誘・採用・雇用への誘導、宣伝・スパム行為、ハラスメント・脅迫・不当な要求、個人情報の不正収集、その他公序良俗に反する行為。",
      "運営者は、安全管理・規約違反調査・トラブル対応の目的に限り、必要に応じてメッセージ内容を確認することがあります。利用者はこの点に同意のうえでメッセージ機能を利用してください。",
      "メッセージ内容に規約違反が認められた場合、運営者は当該メッセージの削除・アカウントの停止・利用制限を行うことができます。",
    ],
  },
  {
    id: "7",
    title: "第7条（禁止事項）",
    content: [
      "本サービス上での以下の行為を禁止します：法令・公序良俗に反する行為、運営者または第三者の知的財産権を侵害する行為、サービスの運営を妨害する行為、不正アクセスやサイバー攻撃、虚偽情報の流布、事業者・消費者・運営者への名誉毀損・誹謗中傷、本サービスを通じた採用・雇用仲介行為、多重アカウントの作成、その他運営者が不適切と判断する行為。",
      "禁止事項に違反した場合、運営者は通知なくアカウント停止・利用制限・法的措置を講じることができます。",
    ],
  },
  {
    id: "8",
    title: "第8条（通報機能）",
    content: [
      "利用者は、コンテンツ・事業者ページ・レビュー・メッセージに規約違反や不適切な内容があると判断した場合、通報機能を通じて運営者に報告できます。",
      "運営者は通報内容を確認し、必要に応じて該当コンテンツの削除・アカウント停止・警告を行います。悪意ある虚偽の通報は禁止されています。",
    ],
  },
  {
    id: "9",
    title: "第9条（知的財産権）",
    content: [
      "本サービス上に掲載されたコンテンツ（動画・文章・画像・ロゴ等）の知的財産権は、運営者または正当な権利者に帰属します。",
      "消費者は、購入したコンテンツを個人の学習目的にのみ利用できます。複製・二次配布・転売・無断転用は固く禁じます。",
      "事業者は、出品するコンテンツについて、必要な権利を有することを保証するものとします。",
    ],
  },
  {
    id: "10",
    title: "第10条（免責事項）",
    content: [
      "運営者は、本サービスを通じて提供されるコンテンツの正確性・完全性・有用性について保証しません。コンテンツの利用により生じた損害について、運営者は一切の責任を負いません。",
      "本サービスの停止・中断・終了により利用者に損害が生じた場合、運営者の故意・重過失がある場合を除き、運営者は責任を負いません。",
      "事業者と消費者の間で生じたトラブルについて、運営者が仲介・調停を行う義務はありませんが、必要に応じて適切な措置を講じることがあります。",
    ],
  },
  {
    id: "11",
    title: "第11条（退会・アカウント削除）",
    content: [
      "利用者はいつでも本サービスの退会手続きをとることができます。退会手続き後、アカウント情報は削除されます。",
      "ただし、法令・規約上必要な記録（取引履歴等）は、一定期間保持することがあります。",
      "退会後は購入済みコンテンツへのアクセスが失われます。退会前に必要なダウンロードや情報の保存を行ってください。",
    ],
  },
  {
    id: "12",
    title: "第12条（準拠法・管轄裁判所）",
    content: [
      "本規約の解釈・適用は日本法に準拠します。",
      "本規約に関し紛争が生じた場合、運営者所在地を管轄する地方裁判所を第一審の専属的合意管轄裁判所とします。",
    ],
  },
];

export default function TermsPage() {
  const [openSection, setOpenSection] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-ivory">
      <Navbar />
      <main className="pt-28 pb-16 px-4">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <p className="font-display italic text-gold text-xs tracking-widest mb-2">Legal</p>
            <h1 className="font-serif text-deep-green text-3xl font-light mb-4">利用規約</h1>
            <p className="text-charcoal/50 font-sans text-xs">最終更新日：2025年3月28日</p>
          </div>

          {/* Intro */}
          <div className="bg-deep-green/5 rounded-2xl p-6 mb-8 border border-deep-green/10">
            <p className="text-sm font-sans text-charcoal/80 leading-relaxed">
              本利用規約は、TSUGITE（ツギテ）が提供する教育ECプラットフォームの利用条件を定めたものです。本サービスをご利用いただく前に、以下の内容をよくお読みください。本サービスのご利用は、本規約への同意とみなされます。
            </p>
          </div>

          {/* TOC */}
          <nav className="bg-white rounded-2xl p-6 mb-8 border border-stone-100">
            <p className="font-serif text-deep-green text-base mb-4">目次</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
              {sections.map(s => (
                <a
                  key={s.id}
                  href={`#section-${s.id}`}
                  onClick={() => setOpenSection(s.id)}
                  className="text-sm font-sans text-charcoal/60 hover:text-teal transition-colors cursor-pointer py-1"
                >
                  {s.title}
                </a>
              ))}
            </div>
          </nav>

          {/* Sections */}
          <div className="space-y-3">
            {sections.map(s => (
              <div key={s.id} id={`section-${s.id}`} className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
                <button
                  onClick={() => setOpenSection(openSection === s.id ? null : s.id)}
                  className="w-full px-6 py-5 flex items-center justify-between gap-4 cursor-pointer hover:bg-stone-50 transition-colors text-left"
                >
                  <h2 className="font-serif text-deep-green text-base">{s.title}</h2>
                  <i className={`ri-arrow-down-s-line text-xl text-charcoal/40 transition-transform duration-300 flex-shrink-0 ${openSection === s.id ? "rotate-180" : ""}`} />
                </button>
                {openSection === s.id && (
                  <div className="px-6 pb-6 border-t border-stone-100 pt-4">
                    <div className="space-y-3">
                      {s.content.map((p, i) => (
                        <p key={i} className="text-sm font-sans text-charcoal/80 leading-relaxed">{p}</p>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Links */}
          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/privacy" className="flex items-center justify-center gap-2 px-6 py-3 bg-white rounded-full border border-stone-200 text-sm font-sans text-charcoal/70 hover:border-teal hover:text-teal transition-colors cursor-pointer">
              <i className="ri-shield-line" />プライバシーポリシー
            </Link>
            <Link to="/faq" className="flex items-center justify-center gap-2 px-6 py-3 bg-white rounded-full border border-stone-200 text-sm font-sans text-charcoal/70 hover:border-teal hover:text-teal transition-colors cursor-pointer">
              <i className="ri-question-line" />よくある質問
            </Link>
            <Link to="/contact" className="flex items-center justify-center gap-2 px-6 py-3 bg-white rounded-full border border-stone-200 text-sm font-sans text-charcoal/70 hover:border-teal hover:text-teal transition-colors cursor-pointer">
              <i className="ri-mail-line" />お問い合わせ
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
